export default {"src":"/_next/static/media/eclair.8a52a2c5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};